import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form form-columns_4 gap-20 w-100 flex-column flex-md-row" }
const _hoisted_2 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_3 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_4 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_5 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_6 = { class: "form form-columns_4 gap-20 w-100 flex-column flex-md-row" }
const _hoisted_7 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_8 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_9 = { class: "item rounded bg-light-green pdl-20 pdr-20 pdt-15 pdb-15 cursor-pointer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CheckBox, {
          label: "Work Period",
          className: "alert-checkbox light",
          id: "WorkPeriod",
          modelValue: _ctx.localFields.WorkPeriod,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFields.WorkPeriod) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CheckBox, {
          label: "Member's Name",
          className: "alert-checkbox light",
          id: "Name",
          modelValue: _ctx.localFields.Name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFields.Name) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CheckBox, {
          label: "Member's NBF ID",
          className: "alert-checkbox light",
          id: "PersonID",
          modelValue: _ctx.localFields.PersonID,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFields.PersonID) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CheckBox, {
          label: "Employer",
          className: "alert-checkbox light",
          id: "Employer",
          modelValue: _ctx.localFields.Employer,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFields.Employer) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_CheckBox, {
          label: "Production",
          className: "alert-checkbox light",
          id: "Production",
          modelValue: _ctx.localFields.Production,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFields.Production) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_CheckBox, {
          label: "Payor",
          className: "alert-checkbox light",
          id: "Payor",
          modelValue: _ctx.localFields.Payor,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFields.Payor) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_CheckBox, {
          label: "Receipt Dates",
          className: "alert-checkbox light",
          id: "ReceiptDate",
          modelValue: _ctx.localFields.ReceiptDate,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localFields.ReceiptDate) = $event)),
          onChange: _ctx.emitUpdate,
          showLabel: true
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _hoisted_10
    ])
  ], 64))
}